<template>
  <button @click="exportCreditDeposit" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount" :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportCreditDeposit: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 1000;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/client-register/', {
          params: params
        });

        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            name: item.name,
            email: item.email,
            phone: item.phone,
            role: item.role,
            category: item.category ? item.category.map(c => `${c.code}. ${c.name}`).join(", ") : '',
            companySize: item.companySize,
            useNeed: item.useNeed && item.useNeed.length ? item.useNeed.join(', ') : '',
            updateTime: moment(item.updateTime).format('DD/MM/YYYY HH:mm:ss'),
            code: item.code,
            request: item.request,
            status: item.isSuccess ? this.$t('success') : item.confirmTime ? this.$t('step', [3]) : this.$t('step', [2]),
            utm_source: item.utm_source,
            utm_medium: item.utm_medium,
            utm_campaign: item.utm_campaign,
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);
      if (!this.cancelRequest) {
        workbook.xlsx.writeBuffer({base64: true}).then(data => {
          this.exporting = false;
          saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              'client-register.xlsx');
        }).finally(() => {
          this.cancelRequest = false;
          this.downloadedCount = 0;
        });
      }
    },
    setupSheet: function (sheet) {
      let cols = [
        {header: this.$t('name'), key: 'name', width: 20},
        {header: this.$t('email'), key: 'email', width: 20},
        {header: this.$t('phone'), key: 'phone', width: 20},
        {header: this.$t('role'), key: 'role', width: 20},
        {header: this.$t('businessCategory'), key: 'category', width: 20},
        {header: this.$t('companySize'), key: 'companySize', width: 20},
        {header: this.$t('useNeed'), key: 'useNeed', width: 20},
        {header: this.$t('updateTime'), key: 'updateTime', width: 20},
      ];
      if (!['sales', 'kpiSales'].includes(this.$store.state.user.role)) {
        cols.push({header: 'Code', key: 'code', width: 20});
      }
      cols.push(
          {header: 'Request', key: 'request', width: 20},
          {header: this.$t('status'), key: 'status', width: 20},
          {header:' utm_source', key: 'utm_source', width: 20},
          {header: 'utm_medium', key: 'utm_medium', width: 20},
          {header: 'utm_campaign', key: 'utm_campaign', width: 20}
      )
      sheet.columns = cols;
    },
    close() {
      this.cancelRequest = true;
    },
  },
  i18n: {
    messages: {
      vi: {
        companySize: "Số lượng nhân viên",
        useNeed: "Nhu cầu",
        role: "Vị trí trong công ty",
        step: "Bước {0}"
      },
      en: {
        companySize: "Company size",
        useNeed: "Use need",
        role: "Role in company",
        step: "Step {0}"
      },
    }
  }
}
</script>
